<template>
  <div class="shortcutMenuContainer" :class="shortcutMenuClass">
    <div class="chatInputIconContainer">
      <a @click.stop.prevent="toggleMenu">
        <i class="fas" :class="[menuClass, { disabled: isDisabled }]" aria-hidden="true"></i>
      </a>
    </div>
    <transition mode="out-in" name="slide-fade" @after-enter="afterEnterTransition" @after-leave="afterLeaveTransition">
      <div v-show="isMenuOpened" class="menuContainer" :class="{ active: transitionFinished }">
        <template v-for="(menuItem, index) in menuItems">
          <div v-if="shouldDisplayChip(menuItem.payload)" :key="index" class="menuItem" @click="sendMessage(menuItem)">
            <span>{{ menuItem.mainContent }}</span>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>
<script>
// Libs
import { sendMessage, shouldDisplayChip } from '../lib/chipMessage'

// Config
import config from '../config/'

export default {
  name: 'ShortcutMenu',
  props: {
    menuItems: { type: Array, required: true },
    shortcutMenuClass: { type: String, required: true },
    isKiosk: { type: Boolean, required: true },
    assistantId: { type: String, required: true },
    isDisabled: { type: Boolean, default: false }
  },
  data: function() {
    return {
      isMenuOpened: false,
      transitionFinished: false
    }
  },
  computed: {
    menuClass: function() {
      return this.isMenuOpened ? 'fa-times' : 'fa-bars'
    }
  },
  watch: {
    isDisabled: function() {
      if (this.isDisabled) {
        this.isMenuOpened = false
      }
    }
  },
  methods: {
    shouldDisplayChip,
    trackMenuEvent(eventType, inputType, mainContent = null) {
      const data = [
        {
          event: {
            eventType,
            element: config.EVENT_ELEMENTS.MENU
          },
          ...{ mainContent },
          inputType
        }
      ]
      this.$store.dispatch('socket_userTracking', data)
    },
    toggleMenu(trackEvent = true) {
      if (this.isDisabled) {
        return
      }

      this.isMenuOpened = !this.isMenuOpened

      if (!trackEvent) {
        return
      }

      // Send tracking info menu open/close event
      const eventType = this.isMenuOpened ? config.EVENT_TYPES.OPEN : config.EVENT_TYPES.CLOSE
      this.trackMenuEvent(eventType, config.INPUT_TYPES.TOUCH)
    },
    sendMessage(menuItem) {
      if (this.isDisabled) {
        return
      }

      sendMessage(
        this.$store,
        menuItem.payload,
        menuItem.mainContent,
        config.SOURCE_TYPES.MENU,
        this.assistantId,
        this.$t('location_permission_error'),
        config.EVENT_ELEMENTS.MENU_LINK,
        this.isKiosk
      )

      this.toggleMenu(false)
    },
    afterEnterTransition() {
      this.transitionFinished = true
    },
    afterLeaveTransition() {
      this.transitionFinished = false
    }
  }
}
</script>
